<template>
  <div class="flex items-center justify-center">
    <div class="grid grid-cols-2fr-3fr grid-rows-0.25fr-1fr">
      <h1 class="col-start-1 col-end-3 row-start-1 row-end-2 text-xl w-full ml-8 font-semibold max-md:text-lg max-md:ml-0">
        {{ $t(title) }}
      </h1>
      <h1 class="col-start-1 col-end-3 row-start-2 row-end-3 text-xl w-full ml-8 mb-8 font-semibold max-md:text-lg max-md:ml-0">
        {{ $t(subTitle) }}
      </h1>
      <div class="mx-auto col-start-1 col-end-2 row-start-3 row-end-4">
        <img src="@/assets/images/receipt.png" :alt="imageAlt" />
      </div>
      <ul
        class="flex flex-col justify-evenly row-start-3 row-end-4 col-start-2 col-end-3 mb-10"
      >
        <li v-for="(item, index) in items" :key="index">
          <span class="mr-2 text-primary font-bold text-lg">{{ $t(item.label) }}</span>
          <span class="text-md">{{ $t(item.text) }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'receipt-information',
  props: {
    title: {
      type: String,
      required: true,
      default: 'Please take a picture of the receipt/invoice.'
    },
    subTitle: {
      type: String,
      required: true,
      default: 'The following information must be visible:'
    },
    imageSrc: {
      type: String,
      required: true
    },
    imageAlt: {
      type: String,
      default: 'Receipt Example'
    },
    items: {
      type: Array,
      required: true,
      default: () => [
        { label: 'A', text: 'Store name' },
        { label: 'B', text: 'Participating products and their price' },
        { label: 'C', text: 'The total amount of the tax receipt/invoice' },
        { label: 'D', text: 'Date and time on the tax receipt/invoice' },
        { label: 'E', text: 'Receipt slip/invoice number' }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.receiptInfo {
  display: grid;
  grid-template-columns: 2fr 3fr;
  grid-template-rows: 0.25fr 1fr;
}
</style>
